import { zodResolver } from '@hookform/resolvers/zod';
import { type DefaultValues, type FieldValues, useForm } from 'react-hook-form';
import type { z } from 'zod';

/**
 * Formulário validado por schema Zod. Valida ao sair do campo e, depois do primeiro erro, a cada
 * tecla — avisar enquanto a pessoa ainda digita pela primeira vez irrita; deixar o erro parado
 * depois de corrigido confunde.
 */
export function useZodForm<S extends z.ZodType<FieldValues, z.ZodTypeDef, FieldValues>>(
  schema: S,
  defaultValues: DefaultValues<z.input<S>>,
) {
  return useForm<z.input<S>, unknown, z.output<S>>({
    resolver: zodResolver(schema),
    defaultValues,
    mode: 'onTouched',
  });
}
